import React from 'react'

const IconAccount = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.2105 35.1579V31.6842C32.2105 29.8416 31.4786 28.0746 30.1757 26.7716C28.8729 25.4688 27.1057 24.7368 25.2633 24.7368H14.8421C12.9996 24.7368 11.2325 25.4688 9.92961 26.7716C8.62673 28.0746 7.89478 29.8416 7.89478 31.6842V35.1579" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.0526 17.7895C23.8895 17.7895 26.9999 14.6791 26.9999 10.8421C26.9999 7.00521 23.8895 3.89478 20.0526 3.89478C16.2157 3.89478 13.1052 7.00521 13.1052 10.8421C13.1052 14.6791 16.2157 17.7895 20.0526 17.7895Z" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconAccount